// if (process.env.MODE_ENV === 'production'){
//     baseUrl = 'http://localhost:3000'
// }else{
//     baseUrl = 'http://localhost:3000'
// }

// export const apiHost = 'http://192.168.10.9:3011';
// export const apiHost = 'http://localhost:3011';
// export const apiHost = 'http://192.168.10.8:1005';
export const apiHost = 'https://analysis.accugenelab.com:1005';
export const secretKey = 'accugene';
